import { defineComponent, ref, nextTick, PropType } from 'vue';
import { ElMessage, ElForm } from 'element-plus';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import { exportByBlob } from '@/core/utils/file-download';

export default defineComponent({
  emits: ['update:visible'],
  props: {
    dictCodes: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const exportColumns = ref([
      '字典编号',
      '字典值父编号',
      '字典值编号',
      '字典值',
      '字典值排序',
      '字典值渠道',
      '来源方',
      '字典值是否启用',
      '字典值路径',
      '字典值层级',
      '字典值备注',
      '原字典编号',
      '字典名称',
      '字典排序',
      '字典渠道',
      '字典来源方',
      '字典是否启用',
      '字典备注',
    ]);
    const handleCloseDialog = () => {
      emit('update:visible', false);
    };

    const form = ref<{
      columns: string[];
    }>({
      columns: [],
    });
    const refForm = ref<InstanceType<typeof ElForm> | null>(null);
    const handleOpenDialog = async () => {
      try {
        await nextTick();
        refForm.value?.resetFields();
        form.value.columns = [...exportColumns.value];
      } catch (e) {
        console.log(e);
      }
    };
    // 保存
    const handleSave = async () => {
      try {
        await nextTick();
        await refForm.value?.validate();
        await exportByBlob({
          url: '/ufg/web/v1/dict-value/download-dict-value-info-excel',
          loading: true,
          data: {
            exportNames: form.value.columns,
            dictCodes: props.dictCodes,
          },
          server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
        });
        ElMessage.success('导出成功');
        handleCloseDialog();
      } catch (err) {
        console.log(err);
      }
    };
    return {
      exportColumns,
      handleCloseDialog,
      handleOpenDialog,
      form,
      refForm,
      handleSave,
      rules: {
        columns: [
          {
            required: true,
            message: '选项不能为空',
          },
        ],
      },
    };
  },
  render() {
    return (
      <el-dialog
        title={'请选择导出的表头'}
        modelValue={this.visible}
        onClose={this.handleCloseDialog}
        onOpen={this.handleOpenDialog}
        center
        width="500px"
        close-on-press-escape={false}
        close-on-click-modal={false}
        custom-class="dialog-width-medium el-dialog-inner-scroll"
        v-slots={{
          footer: () => (
            <div class="align-center">
              <el-button size="default" onClick={this.handleCloseDialog}>
                取 消
              </el-button>
              <el-button type="primary" size="default" onClick={this.handleSave}>
                导出
              </el-button>
            </div>
          ),
        }}
      >
        <el-form
          model={this.form}
          label-width=""
          style="width: 430px"
          size="default"
          rules={this.rules}
          ref="refForm"
        >
          <el-form-item label="" prop="columns">
            <el-checkbox-group v-model={this.form.columns}>
              {this.exportColumns.map(v => (
                <el-checkbox label={v} key={v} />
              ))}
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-dialog>
    );
  },
});
